import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import _ from 'lodash';

import SessionsList from '../../components/sessions/SessionsList';
import ReactPaginate from 'react-paginate';
import Spinner from '../../components/generics/Spinner';
import ListHeader from '../../components/generics/ListHeader';
import Filter from '../../components/generics/Filter';

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';

import {
  fetchSessions,
  fetchSessionsSuccess,
  fetchSessionsFailure,
  fetchStations,
  fetchStationsSuccess,
  fetchStationsFailure,
} from "../../store/sessions/actions";
import { withRouter } from "utils/WithRouter";

export class SessionsListContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      sessionNumber: '',
      sessionDate: '',
      sessionStation: undefined,
    }

    this.debounceSearch = _.debounce(this.filterList, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const sessionNumber = params.id ? params.id : undefined;
    const sessionDate = params.date ? params.date : '';
    const sessionStation = params.station ? params.station : undefined;
    const currentPage = params.page ? params.page : STARTING_PAGE;

    this.setState({ currentPage, sessionNumber, sessionDate, sessionStation}, () => {
      this.props.fetchSessions(currentPage, sessionNumber, sessionDate, sessionStation);
    });

    if (this.props.stationsList.stations.length === 0){
      this.props.fetchStations();
    }
  }

  // ---------------------------------------------------------------------------
  // Edit Session
  // ---------------------------------------------------------------------------
  editSession = (sId,finished) => {
    if(finished){
      this.props.history.push('/session/' + sId);
    }else{
      this.props.history.push('/session/' + sId  + '/edit');
    }
  };

  // ---------------------------------------------------------------------------
  // Filters
  // ---------------------------------------------------------------------------
  onSessionNumberChange = (event) => {
    const sessionNumber = event.target.value ? event.target.value : '';
    this.setState({ sessionNumber, currentPage: STARTING_PAGE }, () => {
      this.debounceSearch();
    });
  };

  onSessionDateChange = (event) => {
    const sessionDate = event.target.value ? event.target.value : '';
    this.setState({ sessionDate, currentPage: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  onSessionStationChange = (event) => {
    const sessionStation = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined;
    this.setState({ sessionStation, currentPage: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  filterList = () => {
    let params = {};
    if (this.state.sessionNumber){
      params.session = this.state.sessionNumber;
    }
    if (this.state.sessionDate){
      params.date = this.state.sessionDate;
    }
    if (this.state.sessionStation){
      params.station = this.state.sessionStation;
    }
    params.page = this.state.currentPage;
    this.props.history.push({
      search: queryString.stringify(params)
    });
    this.props.fetchSessions(this.state.currentPage,
                             this.state.sessionNumber,
                             this.state.sessionDate,
                             this.state.sessionStation);
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let currentPage = data.selected + 1;
    if(currentPage !== this.state.currentPage){
      this.setState({ currentPage }, () => {
          this.filterList();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    return (
      <div className="animated fadeIn">
        <div className="card">
          <ListHeader title="Production" iconClass="fa fa-industry mr-05" actionLink={'/session/new'} />
          <Filter
            searchLabel="Session Number"
            searchPlaceholder="Session number"
            searchVal={this.state.sessionNumber}
            onSearchChange={this.onSessionNumberChange}
            dateLabel="Session Date"
            dateVal={this.state.sessionDate}
            onDateChange={this.onSessionDateChange}
            dropdownLabel="Station"
            dropdownPlaceholder="Select station"
            dropdownVal={this.state.sessionStation}
            onDropdownChange={this.onSessionStationChange}
            dropdownByElementId
            dropdownOptions={this.props.stationsList.stations.results}
          />
        </div>

        <div className="card">
          <div className="card-block m-0 p-0">
            <table className="table table-striped table-bordered datatable mb-0">
              <thead>
                <tr>
                  <th>Session Number</th>
                  <th className="hidden-xxs-down">Date</th>
                  <th className="hidden-xs-down">Station</th>
                  <th className="hidden-xs-down">User</th>
                  <th className="hidden-xs-down">Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <SessionsList sessions={this.props.sessionsList} editSession={this.editSession}/>
            </table>
            {this.props.sessionsList.pages > 1 &&
              <ReactPaginate pageCount={this.props.sessionsList.pages}
                             pageRangeDisplayed={2}
                             marginPagesDisplayed={1}
                             previousLabel="<"
                             nextLabel=">"
                             onPageChange={this.handlePageRequest}
                             initialPage={this.state.currentPage-1}
                             disableInitialCallback={true}
                             containerClassName="pagination"
                             pageClassName="page-item"
                             pageLinkClassName="page-link"
                             activeClassName="page-item active"
                             previousClassName="paginate_button previous"
                             nextClassName="paginate_button next"
                             disabledClassName="page-item disabled"
                             forcePage={this.state.currentPage-1}/>
            }
          </div>
        </div>
        {this.props.sessionsList.loading ?
          <Spinner />
        :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    sessionsList: state.sessions.sessionsList,
    stationsList: state.sessions.stationsList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSessions: (page, id, date_created, station) => {
      dispatch(fetchSessions(page, id, date_created, station)).payload.then((response) => {
        dispatch(fetchSessionsSuccess(response.data))
      }, (error) => {
        dispatch(fetchSessionsFailure(error));
      });
    },
    fetchStations: () => {
      dispatch(fetchStations()).payload.then((response) => {
        dispatch(fetchStationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchStationsFailure(error));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SessionsListContainer));
